<template>
  <el-container class="register-page" v-if="id == '53' || id == '54' || id == '55'">
    <el-main style="padding: 0 0 0 0!important" v-if="!qrcodeForm.show">
      <div class="main">
        <img :src="banner"/>
        <el-form v-if="ruleForm.show" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
                 class="ruleForm">
          <el-form-item>
            <el-select class="lang" v-model="ruleForm.lang" @change="selectLang()"
                       placeholder="语言/語言/Language"
                       size="mini">
              <el-option v-for="item in options" :key="item.value" :value="item.value"
                         :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="countryArea">
            <el-autocomplete style="width:100%" clearable v-model="ruleForm.countryArea"
                             :fetch-suggestions="querySearch" :placeholder="$t('register.countryArea')"
                             @change="handleCountryArea" @select="handleSelect">
              <template slot-scope="{ item }">
                <span class="value">{{ item.value }}</span>
                <span class="code">&nbsp;+{{ item.code }}</span>
              </template>
              <el-button slot="prepend" icon="el-icon-location"></el-button>
            </el-autocomplete>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input clearable v-model="ruleForm.phone" @change="handlePhone" minlength="5" maxlength="16"
                      type="text" :placeholder="$t('register.phone')">
              <i slot="prepend">+{{ ruleForm.area }}</i>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input clearable v-model="ruleForm.code" type="text" minlength="4" maxlength="6"
                      @change="handleCode" :placeholder="$t('register.code')">
              <el-button slot="prepend" v-loading="ruleForm.loading" icon="el-icon-chat-dot-round"
                         @click="submitForm('ruleForm')"></el-button>
              <el-button slot="append" class="sms" v-loading="ruleForm.loading" v-if="!isDisabled"
                         @click="validator()">{{ $t('register.sms') }}
              </el-button>
              <el-button slot="append" v-if="isDisabled" disabled>{{ count }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-loading="ruleForm.loading" class="next" size="medium" type="primary"
                       @click="submitForm('ruleForm')">{{ $t('register.next') }}
            </el-button>
          </el-form-item>
        </el-form>
        <el-form ref="cardForm" :model="ruleForm" :rules="cardRules" v-if="cardForm.show" class="ruleForm"
                 :label-width="id == '55' ? '150px' : '100px'">
          <el-form-item prop="name" :label="$t('register.name')">
            <el-input clearable ref="name" v-model="ruleForm.name"
                      :placeholder="$t('register.input') + $t('register.name')"></el-input>
          </el-form-item>
          <el-form-item prop="remark1" :label="$t('register.remark1')">
            <el-select style="width:100%" :placeholder="$t('register.input') + $t('register.remark1')"
                       ref="remark1" v-model="ruleForm.remark1">
              <el-option value="11/12/2021" label="11/12/2021"></el-option>
              <el-option value="12/12/2021" label="12/12/2021"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="remark2" :label="$t('register.remark2')">
            <el-select style="width:100%" :placeholder="$t('register.input') + $t('register.remark2')"
                       ref="remark2" v-model="ruleForm.remark2">
              <el-option value="10:00 – 11:00" label="10:00 – 11:00"></el-option>
              <el-option value="11:00 – 12:00" label="11:00 – 12:00"></el-option>
              <el-option value="12:00 – 13:00" label="12:00 – 13:00"></el-option>
              <el-option value="13:00 – 14:00" label="13:00 – 14:00"></el-option>
              <el-option value="14:00 – 15:00" label="14:00 – 15:00"></el-option>
              <el-option value="15:00 – 16:00" label="15:00 – 16:00"></el-option>
              <el-option value="16:00 – 17:00" label="16:00 – 17:00"></el-option>
              <el-option value="17:00 – 18:00" label="17:00 – 18:00"></el-option>
              <el-option v-if="ruleForm.remark1 == '11/12/2021'" value="18:00 – 19:00"
                         label="18:00 – 19:00"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button class="prev" size="medium" type="primary" @click="prev('ruleForm')">{{
                $t('register.prev')
              }}
            </el-button>
            <el-button class="next" size="medium" type="primary" @click="submit()">{{
                $t('register.submit')
              }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-main>
    <el-main class="main" v-if="qrcodeForm.show" style="text-align: center;">
      <img :src="bannerMoblie" style="width:100%;"/>
      <div class="qrcodeView" style="text-align: center;">
        <div style="padding-top:6px">
          <h5>{{ ruleForm.remark }}</h5>
        </div>
        <div style="padding-top:6px">
          <h5>{{ ruleForm.name }}</h5>
        </div>
        <div style="padding-top:6px">
          <img :style="width" v-if="qrcodeForm.show" id="qrcode" :src="qrcodeForm.qrcode"/>
        </div>
      </div>
    </el-main>
  </el-container>
  <el-container class="register-page" v-else>
    <el-main class="main" v-if="bannerMoblie != '' && qrcodeForm.show" style="text-align: center;">
      <img :src="bannerMoblie" style="width:100%;"/>
      <div class="qrcodeCard" style="text-align: center;">
        <div style="padding-top:6px">
          <h5>{{ ruleForm.name }}</h5>
        </div>
        <div style="padding-top:6px">
          <h5>{{ ruleForm.company }}</h5>
        </div>
        <div style="padding-top:6px">
          <img :style="width" v-if="qrcodeForm.show" id="qrcode" :src="qrcodeForm.qrcode"/>
        </div>
      </div>
    </el-main>
    <el-main v-else style="padding: 0 0 0 0!important">
      <div class="main" ref="main">
        <img :src="banner" v-if="banner != ''" v-show="bannerMoblie == '' || !qrcodeForm.show"/>
        <el-form v-if="ruleForm.show" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
                 class="ms-content">
          <el-form-item v-if="!id">
            <h2>{{ $t('register.title') }}</h2>
          </el-form-item>
          <el-form-item v-if="!id">
            <el-select v-model="projectId" v-if="!id" @change="selectProject()" placeholder="项目选择"
                       style="width: 100%;text-align: center">
              <el-option v-for="item in projects" :key="item.projectId" :value="item.projectId"
                         :label="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="!id">
            <el-select v-model="id" @change="init()" placeholder="注册通道"
                       style="width: 100%;text-align: center">
              <el-option v-for="item in registers" :key="item.registerId" :value="item.registerId"
                         :label="item.name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="id">
            <el-select class="lang" v-model="ruleForm.lang" @change="selectLang()"
                       placeholder="语言/語言/Language"
                       size="mini">
              <el-option v-for="item in options" :key="item.value" :value="item.value"
                         :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="id" prop="countryArea">
            <el-autocomplete style="width:100%" clearable v-model="ruleForm.countryArea"
                             :fetch-suggestions="querySearch" :placeholder="$t('register.countryArea')"
                             @change="handleCountryArea" @select="handleSelect">
              <template slot-scope="{ item }">
                <span class="value">{{ item.value }}</span>
                <span class="code">&nbsp;+{{ item.code }}</span>
              </template>
              <el-button slot="prepend" icon="el-icon-location"></el-button>
            </el-autocomplete>
          </el-form-item>
          <el-form-item v-if="id" prop="phone">
            <el-input clearable v-model="ruleForm.phone" @change="handlePhone" minlength="5" maxlength="16"
                      type="text" :placeholder="$t('register.phone')">
              <!-- <country-code-selector slot="prepend" :countryCode.sync="ruleForm.area"></country-code-selector> -->
              <i slot="prepend">+{{ ruleForm.area }}</i>
            </el-input>
          </el-form-item>
          <el-form-item v-if="id" prop="code">
            <el-input clearable v-model="ruleForm.code" type="text" minlength="4" maxlength="6"
                      @change="handleCode" :placeholder="$t('register.code')">
              <el-button slot="prepend" v-loading="ruleForm.loading" icon="el-icon-chat-dot-round"
                         @click="submitForm('ruleForm')"></el-button>
              <el-button slot="append" class="sms" v-loading="ruleForm.loading" v-if="!isDisabled"
                         @click="validator()">{{ $t('register.sms') }}
              </el-button>
              <el-button slot="append" v-if="isDisabled" disabled>{{ count }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item v-if="id">
            <el-button v-loading="ruleForm.loading" class="next" size="medium" type="primary"
                       @click="submitForm('ruleForm')">{{ $t('register.next') }}
            </el-button>
          </el-form-item>
        </el-form>
        <!--        <footer v-if="ruleForm.show" class="footer" v-html="id=='72'?$t('register.footer_plpex'):id=='73'?$t('register.footer_mfe'):$t('register.footer')"></footer>-->
        <el-form v-if="cardForm.show" label-width="0px" class="ms-content">
          <el-form-item>
            <h2>{{ $t('register.businessCard') }}</h2>
          </el-form-item>
          <el-form-item>
            <input accept="image/*" type="file" ref="file" @change="selectFile"/>
            <input accept="image/*" type="file" ref="upload" capture="camera" @change="selectFile"/>
          </el-form-item>
          <el-form-item>
            <div class="card" @click="select('card')">
              <img src="../assets/img/card.png" @click="select('card')"/>
              <p>{{ $t('register.card') }}</p>
              <p>&nbsp;</p>
            </div>
            <div class="edit" @click="select('edit')">
              <img src="../assets/img/witer.png" @click="select('edit')"/>
              <p>{{ $t('register.edit') }}</p>
              <p>&nbsp;</p>
            </div>
            <span
                :style="ruleForm.lang == 'en' ? 'font-size:11px; display: inline-block;width: 100%;' : 'font-size:13px; display: inline-block;width: 100%;'">*{{
                $t('register.camera')
              }}</span>
          </el-form-item>
          <el-form-item>
            <el-button class="prev" size="medium" type="primary" @click="prev('ruleForm')">{{
                $t('register.prev')
              }}
            </el-button>
            <el-button class="next" size="medium" type="primary" @click="next('personalForm')">{{
                $t('register.next')
              }}
            </el-button>
          </el-form-item>
        </el-form>
        <div class="foot" v-if="cardForm.card">
          <input accept="image/*" type="file" ref="file" @change="selectFile"/>
          <input accept="image/*" type="file" ref="upload" capture="camera" @change="selectFile"/>
          <div class="photograph" @click="select('photograph')">{{ $t('register.photograph') }}</div>
          <div class="gallery" @click="select('gallery')">{{ $t('register.gallery') }}</div>
          <div class="cancel" @click="select('cancel')">{{ $t('register.cancel') }}</div>
        </div>
        <el-steps v-if="!cardForm.show && !ruleForm.show && !qrcodeForm.show" align-center
                  :active="(confirmForm.show ? 2 : page == 0 ? 0 : page > 0 ? 1 : 3)" finish-status="success">
          <el-step :title="$t('register.title1')"></el-step>
          <el-step :title="$t('register.title2')"></el-step>
          <el-step :title="$t('register.title3')"></el-step>
          <el-step :title="$t('register.title4')"></el-step>
        </el-steps>
        <el-form v-if="personalForm.show" :model="ruleForm" :rules="rulesPersonal" ref="personalForm"
                 label-width="150px" style="overflow:auto" class="ms-content">
          <el-form-item label-width="0px">
            <h2>{{ $t('register.info') }}</h2>
          </el-form-item>
          <el-form-item v-if="page > 0" label-width="0">
            <h3>{{ $t('register.person') + '(' + page + ')' }}</h3>
          </el-form-item>
          <el-form-item prop="phoneNo" :label="$t('register.phoneNo')">
            <el-input clearable v-model="ruleForm.phoneNo"
                      :placeholder="$t('register.input') + $t('register.phoneNo')"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.type === 7" prop="idCardUrl" :label="$t('register.idCardUrl')">
            <div class="card" @click="select('card.idCardUrl')">
              <img v-if="ruleForm.idCardUrl" :src="ruleForm.idCardUrl" @click="select('card.idCardUrl')"/>
              <img v-else src="../assets/img/card.png" @click="select('card.idCardUrl')"/>
              <p>{{ $t('register.idCardUrl') }}</p>
              <p>&nbsp;</p>
            </div>
          </el-form-item>
          <el-form-item prop="idCard" :label="$t('register.idCard')">
            <el-input ref="idCard" :readonly="ruleForm.type === 7" clearable v-model="ruleForm.idCard"
                      :placeholder="$t('register.input') + $t('register.idCard')"></el-input>
          </el-form-item>
          <el-form-item prop="name" :label="$t('register.name')">
            <el-input clearable ref="name" :readonly="ruleForm.type === 7" v-model="ruleForm.name"
                      :placeholder="$t('register.input') + $t('register.name')"></el-input>
          </el-form-item>
          <el-form-item prop="nameEn" :label="$t('register.nameEn')">
            <el-input clearable v-model="ruleForm.nameEn"
                      :placeholder="$t('register.input') + $t('register.nameEn')"></el-input>
          </el-form-item>
          <el-form-item prop="sex" :label="$t('register.sex')">
            <el-select style="width:100%" v-model="ruleForm.sex"
                       :placeholder="$t('register.input') + $t('register.sex')">
              <el-option v-for="(option, i) in sexs" :value="option.value"
                         :label="option.label"></el-option>
            </el-select>
            <i slot="prepend" icon="el-icon-user"></i>
            <el-input v-if="ruleForm.sex == '其他' || ruleForm.sex == 'Others'"
                      v-model="ruleForm.sexOthers"></el-input>
          </el-form-item>
          <el-form-item v-if="page == 0 && ruleForm.type === 7" prop="company"
                        :label="$t('register.company')">
            <el-input clearable maxlength="255" minlength="6" v-model="ruleForm.company"
                      :placeholder="$t('register.input') + $t('register.companyName')"></el-input>
          </el-form-item>
          <!--                    @input="clearRule('companyEn')"-->
          <el-form-item v-if="page == 0 && ruleForm.type === 7" prop="companyEn"
                        :label="$t('register.companyEn')">
            <el-input clearable maxlength="255" minlength="6" v-model="ruleForm.companyEn"
                      :placeholder="$t('register.input') + $t('register.companyName')"></el-input>
          </el-form-item>
          <!--                    @input="clearRule('company')"-->
          <el-form-item v-if="ruleForm.type === 7" prop="department" :label="$t('register.department')">
            <el-input clearable v-model="ruleForm.department"
                      :placeholder="$t('register.input') + $t('register.department')"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.type === 7" prop="position" :label="$t('register.position')">
            <el-input clearable v-model="ruleForm.position"
                      :placeholder="$t('register.input') + $t('register.position')"></el-input>
          </el-form-item>
          <!--                    <el-form-item v-if="ruleForm.type===7" :label="$t('register.address')">-->
          <!--                        <el-cascader-->
          <!--                                style="width: 100%"-->
          <!--                                clearable-->
          <!--                                size="large"-->
          <!--                                :options="areaOptions"-->
          <!--                                v-model="selectedOptions"-->
          <!--                                @change="handleChange"-->
          <!--                        ></el-cascader>-->
          <!--                    </el-form-item>-->
          <!--                    <el-form-item v-if="ruleForm.type===7" prop="countryArea" :label="$t('register.countryArea')">-->
          <!--                        <el-autocomplete-->
          <!--                                style="width:100%"-->
          <!--                                clearable-->
          <!--                                v-model="ruleForm.countryArea"-->
          <!--                                :fetch-suggestions="querySearch"-->
          <!--                                :placeholder="$t('register.countryArea')"-->
          <!--                                @select="handleSelect"-->
          <!--                        ></el-autocomplete>-->
          <!--                    </el-form-item>-->
          <!--                    <el-form-item v-show="ruleForm.type===7" prop="province"-->
          <!--                                  v-if="ruleForm.area!=853&&ruleForm.area!=852&&ruleForm.area!=886"-->
          <!--                                  :label="$t('register.province')">-->
          <!--                        <el-autocomplete-->
          <!--                                style="width:100%"-->
          <!--                                v-model="ruleForm.province"-->
          <!--                                clearable-->
          <!--                                :fetch-suggestions="provinceSearch"-->
          <!--                                :placeholder="$t('register.province')"-->
          <!--                                @select="provinceSelect"-->
          <!--                        >-->
          <!--                            <template slot-scope="{ item }">-->
          <!--                                <span>{{ item.name }}</span>-->
          <!--                            </template>-->
          <!--                        </el-autocomplete>-->
          <!--                    </el-form-item>-->
          <!--                    <el-form-item v-show="ruleForm.type===7" prop="city" v-if="ruleForm.area!=853&&ruleForm.area!=852"-->
          <!--                                  :label="$t('register.city')">-->
          <!--                        <el-autocomplete-->
          <!--                                style="width:100%"-->
          <!--                                clearable-->
          <!--                                v-model="ruleForm.city"-->
          <!--                                :fetch-suggestions="citySearch"-->
          <!--                                :placeholder="$t('register.city')"-->
          <!--                                @select="citySelect"-->
          <!--                        >-->
          <!--                            <template slot-scope="{ item }">-->
          <!--                                <span>{{ item.name }}</span>-->
          <!--                            </template>-->
          <!--                        </el-autocomplete>-->
          <!--                    </el-form-item>-->
          <!--                    <el-form-item v-if="ruleForm.type===7" prop="address1" :label="$t('register.address1')">-->
          <!--                        <el-input-->
          <!--                                clearable-->
          <!--                                v-model="ruleForm.address1"-->
          <!--                                :placeholder="$t('register.input')+$t('register.address1')"-->
          <!--                        ></el-input>-->
          <!--                    </el-form-item>-->
          <el-form-item v-if="ruleForm.type === 7" prop="booth" :label="$t('register.booth')">
            <el-input clearable v-model="ruleForm.booth"
                      :placeholder="$t('register.input') + $t('register.booth')"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.type === 7" prop="construction" :label="$t('register.construction')">
            <el-select style="width:100%" v-model="ruleForm.construction"
                       :placeholder="$t('register.input') + $t('register.construction')">
              <el-option v-for="(o, i) in constructions" :value="o.value" :label="o.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.type === 7 && ruleForm.construction !== '普通施工人员'" prop="electricianUrl"
                        :label="$t('register.electricianUrl')">
            <div class="card" @click="select('card.electricianUrl')">
              <img v-if="ruleForm.electricianUrl" :src="ruleForm.electricianUrl"
                   @click="select('card.electricianUrl')"/>
              <img v-else src="../assets/img/card.png" @click="select('card.electricianUrl')"/>
              <p>{{ $t('register.electricianUrl') }}</p>
              <p>&nbsp;</p>
            </div>
          </el-form-item>
          <!--                    <el-form-item v-if="ruleForm.type===7" prop="electrician" :label="$t('register.electrician')">-->
          <!--                        <el-input-->
          <!--                                clearable-->
          <!--                                v-model="ruleForm.electrician"-->
          <!--                                :placeholder="$t('register.input')+$t('register.electrician')"-->
          <!--                        ></el-input>-->
          <!--                    </el-form-item>-->
          <el-form-item v-if="ruleForm.type === 8" prop="carUrl" :label="$t('register.carUrl')">
            <div class="card" @click="select('card.carUrl')">
              <img v-if="ruleForm.carUrl" :src="ruleForm.carUrl" @click="select('card.carUrl')"/>
              <img v-else src="../assets/img/card.png" @click="select('card.carUrl')"/>
              <p>{{ $t('register.carUrl') }}</p>
              <p>&nbsp;</p>
            </div>
          </el-form-item>
          <el-form-item v-if="ruleForm.type === 8" prop="carNo" :label="$t('register.carNo')">
            <el-input clearable v-model="ruleForm.carNo"
                      :placeholder="$t('register.input') + $t('register.carNo')"></el-input>
          </el-form-item>
          <!--          <el-form-item prop="faxNo" :label="$t('register.faxNo')">-->
          <!--            <el-input-->
          <!--                clearable-->
          <!--                v-model="ruleForm.faxNo"-->
          <!--                :placeholder="$t('register.input')+$t('register.faxNo')"-->
          <!--            ></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item prop="webSite" :label="$t('register.webSite')">-->
          <!--            <el-input-->
          <!--                clearable-->
          <!--                v-model="ruleForm.webSite"-->
          <!--                :placeholder="$t('register.input')+$t('register.webSite')"-->
          <!--            ></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item label-width="0px">
            <el-card class="box-card" v-for="(item, j) in ruleForm.list"
                     v-if="(item.input == 'match' || item.input == 'forums' || (item.type == 0 && match)) && page > 0">
              <div slot="header" class="clearfix">
                <span style="color:red" v-show="item.required == 1">*</span>
                <span v-html="item.title"></span>
              </div>
              <div style="padding: 5px" v-for="(option, i) in item.values">
                <div v-if="item.type == 2">
                  <el-radio :checked="option.checked" v-model="item.validator" border="border"
                            size="medium" @change="checked => checkRow(checked, item, option)"
                            :label="option.value">
                    <p v-html="option.value"></p>
                  </el-radio>
                </div>
                <div v-if="item.type == 0 && match">
                  <el-checkbox :checked="option.checked"
                               @change="checked => checkRow(checked, item, option)" border="border"
                               size="medium">
                    <p v-html="option.value"></p>
                  </el-checkbox>
                </div>
              </div>
            </el-card>
          </el-form-item>
          <div class="footerTip">
            <el-form-item :label="$t('register.enabled')" prop="agreeInfo">
              <el-button type="danger" v-text="$t('register.select')" v-on:click="doAgree">
              </el-button>
            </el-form-item>
            <!--  @change="(checked)=>{enabled=checked}"
            <el-checkbox
                    v-if="enabled"
                    v-model="enabled"
                    border="border"
                    size="medium"
            ><span style="white-space: normal;"
                   v-html="$t('register.agree')"></span>
            </el-checkbox>-->
          </div>
          <el-form-item label-width="0px">
            <el-button class="prev" size="medium" type="primary" @click="prev('ruleForm')">{{
                $t('register.prev')
              }}
            </el-button>
            <el-button :disabled="!enabled" class="next" size="medium" type="primary"
                       v-loading="personalForm.loading" @click="submitForm('personalForm')">{{
                $t('register.next')
              }}
            </el-button>
          </el-form-item>
        </el-form>
        <el-form v-if="elseForm.show" :model="ruleForm" ref="elseForm" class="ms-content">
          <el-form-item label-width="0px">
            <h2>{{ $t('register.info') }}</h2>
          </el-form-item>
          <p style="padding:5px">
            {{ $t('register.tip') }} “
            <span style="color:red">✓</span>”
          </p>
          <el-card class="box-card" v-for="(item, j) in ruleForm.list"
                   v-if="(item.input == 'persons' && persons) || (item.input != 'persons' && item.type != 0) || (item.type == 0 && match)">
            <div v-if="(item.type == 0 && item.values.length > 0) || item.type != 0" slot="header"
                 class="clearfix">
              <span style="color:red" v-show="item.required == 1">*</span>
              <span style="white-space:normal">{{ item.title }}</span>
            </div>
            <div style="white-space:normal" v-else v-html="item.title"></div>
            <div v-if="item.values.length > 0" style="padding: 5px" v-for="(option, i) in item.values">
              <div v-if="item.type == 0">
                <el-checkbox :checked="option.checked"
                             @change="checked => checkRow(checked, item, option)"
                             border="border" size="medium">
                  <p v-html="option.value"></p>
                </el-checkbox>
              </div>
              <div v-if="item.type == 4">
                <el-checkbox :checked="option.checked"
                             @change="checked => checkRow(checked, item, option)"
                             border="border" size="medium">
                  <p v-html="option.value"></p>
                </el-checkbox>
                <el-input clearable v-model="item.validator" v-if="i == (item.values.length - 1)"
                          :placeholder="option.value"></el-input>
              </div>
              <div v-else-if="item.type == 2">
                <el-radio :checked="option.checked" v-model="item.validator" border="border"
                          size="medium"
                          @change="checked => checkRow(checked, item, option)" :label="option.value">
                  <p v-html="option.value"></p>
                </el-radio>
              </div>
            </div>
            <div style="padding: 5px" v-if="item.type == 8">
              <el-input-number type="number" size="medium" v-model="item.validator"
                               controls-position="right"
                               style="width:100%" :min="1" :max="9"
                               :placeholder="$t('register.input') + item.title"></el-input-number>
            </div>
          </el-card>
          <el-form-item label-width="0px"></el-form-item>
          <el-form-item label-width="0px">
            <el-button class="prev" size="medium" type="primary" @click="prev('personalForm')">{{
                $t('register.prev')
              }}
            </el-button>
            <el-button class="next" size="medium" v-loading="elseForm.loading" type="primary"
                       @click="submitForm('elseForm')">{{ $t('register.next') }}
            </el-button>
          </el-form-item>
        </el-form>
        <el-form v-if="confirmForm.show" ref="confirmForm" :model="ruleForm" label-width="140px"
                 style="overflow:auto" class="ms-content">
          <el-form-item label-width="0px" style="color:#fff;background-color:#6e9c35;">
            &nbsp;&nbsp;{{ $t('register.confirm') }}
          </el-form-item>
          <div v-for="(option, i) in personalList">
            <el-form-item label-width="0">
              <h3 v-if="i > 0"><img style="width:24px; margin-bottom:-6px;margin-right:6px"
                                    src="../assets/img/person.png"/>{{
                  $t('register.person') + '(' + i + ')'
                }}</h3>
              <el-link style="float:right;padding-left:10px" type="primary"
                       @click="selectPage(option, i)">{{
                  $t('register.update')
                }}
              </el-link>
              <el-link v-if="i > 0" style="float:right" type="primary" @click="deletePage(option, i)">
                {{ $t('register.remove') }}
              </el-link>
            </el-form-item>
            <el-form-item prop="phoneNo" :label="$t('register.phoneNo')">
              <el-input disabled v-model="option.phoneNo"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 7" prop="idCardUrl" :label="$t('register.idCardUrl')">
              <div class="card" @click="select('card.idCardUrl')">
                <img v-if="option.idCardUrl" :src="option.idCardUrl" @click="select('card.idCardUrl')"/>
                <img v-else src="../assets/img/card.png" @click="select('card.idCardUrl')"/>
                <p>{{ $t('register.idCardUrl') }}</p>
                <p>&nbsp;</p>
              </div>
            </el-form-item>
            <el-form-item prop="idCard" :label="$t('register.idCard')">
              <el-input type="idCard" v-model="option.idCard" :readonly="ruleForm.type === 7"
                        :placeholder="$t('register.input') + $t('register.idCard')"></el-input>
            </el-form-item>
            <el-form-item prop="name" :label="$t('register.name')">
              <el-input ref="name" v-model="option.name" :readonly="ruleForm.type === 7"
                        :placeholder="$t('register.input') + $t('register.name')"></el-input>
            </el-form-item>
            <el-form-item prop="sex" :label="$t('register.sex')">
              <el-select style="width:100%" disabled v-model="option.sex"
                         :placeholder="$t('register.input') + $t('register.sex')">
                <el-option v-for="(o, i) in sexs" :value="o.value" :label="o.label"></el-option>
              </el-select>
              <i slot="prepend" icon="el-icon-user"></i>
              <el-input v-if="option.sex == '其他' || option.sex == 'Others'"
                        v-model="option.sexOthers"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 7" prop="company" :label="$t('register.company')">
              <el-input disabled v-model="option.company"
                        :placeholder="$t('register.input') + $t('register.companyName')"></el-input>
            </el-form-item>
            <!--                        @input="clearRule('companyEn')"-->
            <el-form-item v-if="ruleForm.type === 7" prop="companyEn" :label="$t('register.companyName')">
              <el-input disabled v-model="option.companyEn"></el-input>
              <!--                                    @input="clearRule('company')"-->
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 7" prop="department" :label="$t('register.department')">
              <el-input clearable v-model="option.department"
                        :placeholder="$t('register.input') + $t('register.department')"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 7" prop="position" :label="$t('register.position')">
              <el-input disabled v-model="option.position"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 7" prop="address1" :label="$t('register.address1')">
              <el-input disabled v-model="option.address1"></el-input>
            </el-form-item>
            <el-form-item prop="construction" v-if="ruleForm.type === 7"
                          :label="$t('register.construction')">
              <el-select style="width:100%" v-model="option.construction"
                         :placeholder="$t('register.input') + $t('register.construction')">
                <el-option v-for="(o, i) in constructions" :value="o.value"
                           :label="o.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 7 && option.construction !== '普通施工人员'"
                          prop="electricianUrl"
                          :label="$t('register.electricianUrl')">
              <div class="card" @click="select('card.electricianUrl')">
                <img v-if="option.electricianUrl" :src="option.electricianUrl"
                     @click="select('card.electricianUrl')"/>
                <img v-else src="../assets/img/card.png" @click="select('card.electricianUrl')"/>
                <p>{{ $t('register.electricianUrl') }}</p>
                <p>&nbsp;</p>
              </div>
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 7" prop="electrician" :label="$t('register.electrician')">
              <el-input disabled v-model="option.electrician"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 8" prop="carUrl" :label="$t('register.carUrl')">
              <div class="card" @click="select('card.carUrl')">
                <img v-if="option.carUrl" :src="option.carUrl" @click="select('card.carUrl')"/>
                <img v-else src="../assets/img/card.png" @click="select('card.carUrl')"/>
                <p>{{ $t('register.carUrl') }}</p>
                <p>&nbsp;</p>
              </div>
            </el-form-item>
            <el-form-item v-if="ruleForm.type === 8" prop="carNo" :label="$t('register.carNo')">
              <el-input disabled v-model="option.carNo"></el-input>
            </el-form-item>
            <!--            <el-form-item prop="faxNo" :label="$t('register.faxNo')">-->
            <!--              <el-input-->
            <!--                  disabled-->
            <!--                  v-model="option.faxNo"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item prop="webSite" :label="$t('register.webSite')">-->
            <!--              <el-input-->
            <!--                  disabled-->
            <!--                  v-model="option.webSite"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
          </div>
          <el-form-item label-width="0px">
            <el-button class="prev" size="medium" v-loading="confirmForm.loading" type="primary"
                       @click="prev('elseForm')">{{ $t('register.prev') }}
            </el-button>
            <el-button class="next" size="medium" type="primary" v-loading="confirmForm.loading"
                       @click="submitForm('confirmForm')">{{ $t('register.submit') }}
            </el-button>
          </el-form-item>
        </el-form>
        <el-form v-if="qrcodeForm.show && bannerMoblie == ''" ref="qrcodeForm" label-width="0px"
                 class="ms-content">
          <div>
            <el-form-item>
              <p>{{ $t('register.qrcode') }}</p>
            </el-form-item>
            <el-card class="box-card" style="text-align: center;">
              <h3>{{ ruleForm.name }}</h3>
              <h5>&nbsp;</h5>
              <h3>{{ ruleForm.company }}</h3>
              <p>&nbsp;</p>
              <div>
                <img style="width:280px" v-if="qrcodeForm.show" id="qrcode" :src="qrcodeForm.qrcode"/>
              </div>
            </el-card>
            <p>&nbsp;</p>
          </div>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>
<script>
// import countryCodeSelector from "vue-country-code-selector";
import {regionData, CodeToText} from "element-china-area-data";
import area from "../assets/json/area.json";
import areas from "../assets/json/allarea.json";
import allarea from "../assets/json/all.json";
import allChs from "../assets/json/all_chs.json";
import {MessageBox} from 'element-ui';
import {Loading} from "element-ui";
import QRCode from "qrcodejs2";
import axios from "axios";
//let pinyin = require("js-pinyin");
export default {
  inject: ["reloadPage"],
  name: "register",
  // components: {
  //     countryCodeSelector,
  // },
  data: function () {
    return {
      id: "",
      projectId: "",
      projects: [],
      allarea: [],
      restaurants: [],
      registers: [],
      persons: true,
      enabled: false,
      match: false,
      areaOptions: regionData,
      page: 0,
      total: 0,
      arr: areas,
      count: 60,
      timer: null,
      prov: "",
      city: "",
      district: "",
      cityArr: [],
      districtArr: [],
      isDisabled: false,
      selectedOptions: [],
      sexs: [],
      constructions: [],
      phone: "",
      list: [],
      personalList: [],
      upload: false,
      flag: false,
      width: 200,
      url: "",
      banner: "",
      bannerMoblie: "",
      options: [
        {value: "zh", label: "中文简体"},
        {value: "chs", label: "中文繁體"},
        {value: "en", label: "English"},
      ],
      ruleForm: {
        agreeInfo: "",
        booth: "",
        construction: "",
        carNo: "",
        carUrl: "",
        idCardUrl: "",
        electricianUrl: "",
        electrician: "",
        remark: "",
        remark1: "",
        remark2: "",
        openId: "",
        projectId: "",
        registerId: "",
        sourceId: null,
        batch: null,
        type: 0,
        area: 86,
        country: "",
        name: "",
        sex: "",
        company: "",
        companyEn: "",
        department: "",
        postcode: "",
        countryArea: "中国",
        city: "",
        province: "",
        address1: "",
        address2: "",
        address: "",
        position: "",
        telNo: "",
        phoneNo: "",
        faxNo: "",
        idCard: "",
        sexOthers: "",
        webSite: "",
        lang: localStorage.lang,
        loading: false,
        phone: null,
        code: null,
        disabled: 0,
        show: true,
        list: [],
      },
      cardForm: {
        show: false,
        card: false,
        type: "",
      },
      personalForm: {
        show: false,
        loading: false,
      },
      elseForm: {
        loading: false,
        show: false,
      },
      confirmForm: {
        loading: false,
        show: false,
      },
      qrcodeForm: {show: false, qrcode: ""},
      rules: null,
      cardRules: {
        name: [
          {
            required: true,
            message: "請輸入姓名",
            trigger: "change",
          },
        ],
        remark1: [
          {
            required: true,
            message: "請選擇參觀日期",
            trigger: "change",
          },
        ],
        remark2: [
          {
            required: true,
            message: "請選擇預約時段",
            trigger: "change",
          },
        ],
      },
      rulesPersonal: null,
      rulesElse: {},
    };
  },
  methods: {
    doAgree: function () {
      MessageBox.confirm(this.ruleForm.type === 7 ? "施工证为施工人员进场杭州国际博览中心施工现场的唯一凭证，施工证场馆单次收费单场活动使用（12元/张），具体进场安排需听从活动主场单位统一协调，如涉及其他管理费均与杭州国际博览中心无关。应公安要求所有进场施工人员均需进行政治审核，本人己知悉填报须知内容，同意申报并授权通过信息共享方式查询本人相关信息，承诺所提供材料与信息均真实完整合法。并如实选择施工证类型，如选择的证件类型与实际施工内容不符，杭州国际博览中心将有权根据施工报馆手册做出相应的处理。通过公安审核的人员方能办理施工证件进入场馆进行作业。" : "货车通行证为货车进入杭州国际博览中心唯一凭证，此货车证场馆单次收费单次使用（20元/辆/次/4小时），具体进场安排需听从活动主场单位统一协调，如涉及其他管理费均与杭州国际博览中心无关。本人承诺车辆驾驶人员持证上岗,证件在有效期内且所持驾驶证类型与准驾车型相匹配，车辆严格按照证件管理要求，不随意、无序停放车辆。", this.$t('register.enabled'), {
        confirmButtonText: '同意',
        cancelButtonText: '不同意',
        type: 'warning'
      }).then(() => {
        this.enabled = true;
      }).catch(() => {
        this.enabled = false;
      });
    },
    validateCompany(rule, value, callback) {
      if (!value) {
        return callback(new Error('单位名称不能为空'));
      }
      if (value.length < 6) {
        return callback(new Error('请输入公司全称'));
      }

      function validataCredentials(value) {
        return [true, ""];
      }

      setTimeout(() => {
        var res = validataCredentials(value);
        if (!res[0]) {
          callback(new Error(res[1]));
        } else {
          callback();
        }
      }, 200);
    },
    analyzeIDCard: function (userCard) {
      //如果身份证号码为undefind则返回空
      if (!userCard) {
        return false;
      }
      //获取出生年月日
      let yearBirth = userCard.substring(6, 10);
      let monthBirth = userCard.substring(10, 12);
      let dayBirth = userCard.substring(12, 14);
      //获取当前年月日并计算年龄
      let myDate = new Date();
      let monthNow = myDate.getMonth() + 1;
      let dayNow = myDate.getDate();
      let age = myDate.getFullYear() - yearBirth;
      if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
        age--;
      }
      if (age >= 18) {
        return true;
      }
      return false;
    },
    validateSfz(rule, value, callback) {
      if (!value) {
        return callback(new Error('身份证号码不能为空'));
      }

      function analyzeIDCard(userCard) {
        //如果身份证号码为undefind则返回空
        if (!userCard) {
          return false;
        }
        //获取出生年月日
        let yearBirth = userCard.substring(6, 10);
        let monthBirth = userCard.substring(10, 12);
        let dayBirth = userCard.substring(12, 14);
        //获取当前年月日并计算年龄
        let myDate = new Date();
        let monthNow = myDate.getMonth() + 1;
        let dayNow = myDate.getDate();
        let age = myDate.getFullYear() - yearBirth;
        if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
          age--;
        }
        if (age >= 18) {
          return true;
        }
        return false;
      }

      function validataCredentials(num) {
        var msg, boo; //  msg身份证验证友情提示,boo返回值
        var num = num.toUpperCase(); // 身份证为末尾可能是X
        //   身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，
        //   最后一位是校验位，可能为数字或字符X。
        const arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        const arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        let nTemp = 0,
            i;
        if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
          //  输入的身份证号长度不对，或者号码不符合规定;
          return [boo = false, msg = "输入的身份证号长度不对，或者号码不符合规定"];
        }
        //   校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        //   下面分别分析出生日期和校验位
        let len, re;
        len = num.length;
        if (len == 15) {
          re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
          var arrSplit = num.match(re);
          //   检查生日日期是否正确
          var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
          var bGoodDay;
          bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
          if (!bGoodDay) {
            //   输入的身份证号里出生日期不对！
            return [boo = false, msg = "输入的身份证号里出生日期不对！"];
          } else {
            //   将15位身份证转成18位
            //   校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
            for (i = 0; i < 17; i++) {
              nTemp += num.substr(i, 1) * arrInt[i];
            }
            num += arrCh[nTemp % 11];

            if (analyzeIDCard(num)) {
              return [boo = true, msg = num];
            } else {
              return [boo = false, msg = "未成年人不能注册"]
            }
          }
        }
        if (len == 18) {
          re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
          var arrSplit = num.match(re);
          //  检查生日日期是否正确
          var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
          var bGoodDay;
          bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
          if (!bGoodDay) {
            //  输入的身份证号里出生日期不对！

            return [boo = false, msg = " 输入的身份证号里出生日期不对"];
          } else {
            //  检验18位身份证的校验码是否正确。
            //  校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            var valnum;
            for (i = 0; i < 17; i++) {
              nTemp += num.substr(i, 1) * arrInt[i];
            }
            valnum = arrCh[nTemp % 11];
            if (valnum != num.substr(17, 1)) {
              //  18位身份证的校验码不正确！
              return [boo = false, msg = "身份证的校验码不正确！"];
            }
            if (analyzeIDCard(num)) {
              return [boo = true, msg = "验证成功"]
            } else {
              return [boo = false, msg = "未成年人不能注册"]
            }
          }
        }
        return [boo = false, msg = "身份证的长度不正确！"];
      }

      setTimeout(() => {
        var res = validataCredentials(value);
        if (!res[0]) {
          callback(new Error(res[1]));
        } else {
          callback();
        }
      }, 200);
    },
    // validateComapny(rule, value, callback) {
    //     if (this.ruleForm.company == "" && this.ruleForm.companyEn == "") {
    //         callback(
    //             new Error(
    //                 this.$t("register.input") +
    //                 this.$t("register.company") +
    //                 "/" +
    //                 this.$t("register.input") +
    //                 this.$t("register.companyEn")
    //             )
    //         );
    //     } else {
    //         callback();
    //     }
    // },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants;
      cb(results);
    },
    provinceSearch(queryString, cb) {
      let restaurants = this.allarea.filter((item) => {
        return item.parent == this.ruleForm.area.toString();
      });
      let results = queryString
          ? restaurants.filter(this.areaFilter(queryString))
          : restaurants;
      cb(results);
    },
    citySearch(queryString, cb) {
      let restaurants = this.allarea.filter((item) => {
        return item.parent == this.prov.toString();
      });
      let results = queryString
          ? restaurants.filter(this.areaFilter(queryString))
          : restaurants;
      cb(results);
    },
    areaFilter(queryString) {
      return (restaurant) => {
        return (
            restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0
        );
      };
    },
    provinceSelect(item) {
      this.ruleForm.province = item.name;
      this.prov = item.value;
    },
    citySelect(item) {
      this.ruleForm.city = item.name;
      this.city = item.value;
    },
    handleCountryArea(e) {
      localStorage.countryArea = e;
    },
    handlePhone(e) {
      localStorage.phone = e;
    },
    handleCode(e) {
      localStorage.code = e;
    },
    handleSelect(item) {
      try {
        this.ruleForm.faxNo = this.ruleForm.faxNo.replace(
            "+" + this.ruleForm.area,
            "+" + item.code
        );
        this.ruleForm.phoneNo = this.ruleForm.phoneNo.replace(
            "+" + this.ruleForm.area,
            "+" + item.code
        );
        this.ruleForm.telNo = this.ruleForm.telNo.replace(
            "+" + this.ruleForm.area,
            "+" + item.code
        );
      } catch (error) {

      }
      this.ruleForm.area = item.code;
      this.prov = item.value;
      this.ruleForm.countryArea = item.value;
      localStorage.countryArea = item.value;
      localStorage.area = item.code;
    },
    /**
     * 根据身份证号得到姓别和精确计算年龄
     */
    analyzeIDCard: function (userCard) {
      //如果身份证号码为undefind则返回空
      if (!userCard) {
        return false;
      }
      //获取出生年月日
      let yearBirth = userCard.substring(6, 10);
      let monthBirth = userCard.substring(10, 12);
      let dayBirth = userCard.substring(12, 14);
      //获取当前年月日并计算年龄
      let myDate = new Date();
      let monthNow = myDate.getMonth() + 1;
      let dayNow = myDate.getDate();
      let age = myDate.getFullYear() - yearBirth;
      if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
        age--;
      }
      if (age >= 18) {
        return true;
      }
      return false;
    },
    selectPage(option, i) {
      this.ruleForm = option;
      this.page = i;
      this.confirmForm.show = false;
      this.personalForm.show = true;
      this.hangleGoUp();
    },
    deletePage(option, i) {
      this.personalList.splice(i, 1);
    },
    changeProv(o) {
      this.ruleForm.countryArea = o;
    },
    changeCity(o) {
      this.ruleForm.province = o;
    },
    changeDistrict(o) {
      this.ruleForm.city = o;
    },
    provBlur(e) {
      this.prov = e.target.value;
      this.ruleForm.countryArea = e.target.value;
    },
    cityBlur(e) {
      this.city = e.target.value;
      this.ruleForm.province = e.target.value;
    },
    districtBlur(e) {
      this.district = e.target.value;
      this.ruleForm.city = e.target.value;
    },
    updateCity() {
      for (var i in this.arr) {
        var obj = this.arr[i];
        if (obj.name == this.prov) {
          this.cityArr = obj.sub;
          break;
        }
      }
      if (this.cityArr.length > 0) {
        this.city = this.cityArr[0].name;
      }
    },
    updateDistrict() {
      for (var i in this.cityArr) {
        var obj = this.cityArr[i];
        if (obj) {
          if (obj.name == this.city) {
            this.districtArr = obj.sub;
            break;
          }
        }
      }
      if (
          this.districtArr &&
          this.districtArr.length > 0 &&
          this.districtArr[0].name
      ) {
        this.district = this.districtArr[0].name;
      } else {
        this.district = "";
      }
    },
    clearRule(obj) {
      this.$refs.personalForm.clearValidate(obj);
    },
    handleChange() {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        if (i == 0) {
          this.ruleForm.province = CodeToText[this.selectedOptions[i]];
        } else if (i == 1) {
          this.ruleForm.city = CodeToText[this.selectedOptions[i]];
        } else {
          this.ruleForm.address1 =
              CodeToText[this.selectedOptions[i]] + this.ruleForm.address1;
        }
      }
    },
    changeElseRemark(val, item, option, j) {
      option.checked = true;
    },
    checkRow(checked, item, option) {
      if (item.input == "registers") {
        if (localStorage.lang == "en") {
          this.persons = option.value == "Yes";
        } else {
          this.persons = option.value == "是";
        }
      }
      if (item.input == "forums") {
        if (localStorage.lang == "en") {
          this.match = option.value.indexOf("Yes") > -1;
        } else {
          this.match = option.value.indexOf("是") > -1;
        }
      }
      for (let i of this.ruleForm.list) {
        if (i.input == item.input) {
          if (item.type == 2) {
            for (let o of i.values) {
              o.checked = o.value == option.value;
            }
          } else {
            for (let o of i.values) {
              if (o.value == option.value) {
                o.checked = checked;
                break;
              }
            }
          }
        }
      }
    },
    submit() {
      this.$refs["cardForm"].validate((valid) => {
        if (valid) {
          this.ruleForm.avatar = this.ruleForm.idCardUrl;
          this.ruleForm.remark = this.ruleForm.construction;
          this.ruleForm.remark1 = this.ruleForm.carNo;
          if (this.ruleForm.remark1) {
            this.ruleForm.remark =
                this.ruleForm.remark1 + " " + this.ruleForm.remark2;
          }
          this.$axios
              .post("/Personal/", this.ruleForm)
              .then((result) => {
                if (result.data.hasError) {
                  this.$message.error(this.$t("register.error"));
                  this.$message.error(result.data.message);
                } else {
                  if (!this.qrcodeForm.show) {
                    this.elseForm.loading = false;
                    this.elseForm.show = false;
                    this.confirmForm.show = false;
                    this.qrcodeForm.show = true;
                    this.qrcodeForm.qrcode =
                        axios.defaults.baseURL.substr(
                            0,
                            axios.defaults.baseURL.length - 4
                        ) +
                        "/qrcode/" +
                        result.data.data.code;
                    localStorage.setItem("data", result.data.data);
                  }
                }
              })
              .catch((error) => {
                this.confirmForm.loading = false;
                console.log(error);
              });
        }
      });
    },
    prev(type) {
      switch (type) {
        case "ruleForm":
          this.ruleForm.show = true;
          this.cardForm.show = false;
          this.personalForm.show = false;
          this.qrcodeForm.show = false;
          break;
        case "cardForm":
          if (this.page > 0) {
            this.elseForm.show = true;
            this.personalForm.show = false;
            this.confirmForm.show = false;
          } else {
            this.cardForm.show = true;
            this.personalForm.show = false;
          }
          break;
        case "personalForm":
          if (this.page > 0) {
            this.page -= 1;
          } else {
            this.personalForm.show = true;
            this.elseForm.show = false;
          }
          break;
        case "elseForm":
          this.elseForm.show = true;
          this.personalForm.show = false;
          this.confirmForm.show = false;
          break;
      }
    },
    next(type) {
      switch (type) {
        case "elseForm":
          this.elseForm.show = true;
          this.personalForm.show = false;
          break;
        case "personalForm":
          this.ruleForm.telNo = "+" + this.ruleForm.area;
          this.ruleForm.phoneNo =
              "+" + this.ruleForm.area + this.ruleForm.phone;
          this.ruleForm.faxNo = "+" + this.ruleForm.area;

          this.personalForm.show = true;
          this.cardForm.show = false;
          break;
      }
    },
    selectFile(e) {
      this.cardForm.card = false;
      const load = this.$loading({
        lock: true,
        text: "loading...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        let formData = {
          base64: event.target.result,
        };

        if (this.cardForm.type === 'idCardUrl') {
          this.$axios
              .post("/Upload/IdCard", formData)
              .then((res) => {
                load.close();
                if (res.data.hasError == false && res.data.data) {
                  console.log(res.data.data)
                  if (this.total > 1 && this.page > 0) {
                    this.personalList[this.page].idCard = res.data.data.idNum
                    this.personalList[this.page].name = res.data.data.name
                  } else {
                    this.ruleForm.idCard = res.data.data.idNum
                    this.ruleForm.name = res.data.data.name
                  }
                } else {
                  this.$message.error(this.$t("register.idCardError"));
                }
              })
              .catch((error) => {
                console.log(error);
                load.close();
              });
        }

        this.$axios
            .post("/Upload/Base64", formData)
            .then((res) => {
              load.close();
              if (res.data.hasError == false && res.data.data) {
                if (this.total > 1 && this.page > 0) {
                  if (this.cardForm.type === 'carUrl') {
                    this.personalList[this.page].carUrl = res.data.data;
                  } else if (this.cardForm.type === "electricianUrl") {
                    this.personalList[this.page].electricianUrl = res.data.data;
                  } else {
                    this.personalList[this.page].idCardUrl = res.data.data;
                  }
                } else {
                  if (this.cardForm.type === 'carUrl') {
                    this.ruleForm.carUrl = res.data.data;
                  } else if (this.cardForm.type === "electricianUrl") {
                    this.ruleForm.electricianUrl = res.data.data;
                  } else {
                    this.ruleForm.idCardUrl = res.data.data;
                  }
                }
              } else {
                this.$message.error(this.$t("register.cardError"));
              }
            })
            .catch((error) => {
              console.log(error);
              load.close();
            });

        // this.$axios
        //     .post("/UploadCard/Base64", formData)
        //     .then((res) => {
        //       load.close();
        //       if (res.data.hasError == false && res.data.data) {
        //         let personal = JSON.parse(res.data.data);
        //         if (personal.data && personal.message == "success") {
        //           this.personalForm.show = true;
        //           this.cardForm.show = false;
        //           this.ruleForm.company = personal.data.company;
        //           this.ruleForm.idCard = personal.data.idCard;
        //           this.ruleForm.name = personal.data.name;
        //           this.ruleForm.phoneNo = personal.data.mobile;
        //           this.ruleForm.faxNo = personal.data.phoneFax;
        //           this.ruleForm.telNo = personal.data.phoneCompany;
        //           this.ruleForm.website = personal.data.website;
        //           this.ruleForm.address1 = personal.data.address;
        //           this.ruleForm.position = personal.data.title;
        //         } else {
        //           this.$message.error(this.$t("register.cardError"));
        //         }
        //       } else {
        //         this.$message.error(this.$t("register.cardError"));
        //       }
        //     })
        //     .catch((error) => {
        //       console.log(error);
        //       load.close();
        //     });
      };
      reader.readAsDataURL(file);
    },
    select(type) {
      switch (type) {
        case "cancel":
          this.cardForm.card = false;
          break;
        case "gallery":
          this.$refs.file.click();
          break;
        case "photograph":
          this.$refs.upload.click();
          break;
        case "edit":
          // this.personalForm.show = true;
          // this.cardForm.show = false;
          this.next("personalForm");
          break;
        case "card":
        case "card.idCardUrl":
          this.cardForm.card = true;
          this.cardForm.type = 'idCardUrl';
          break;
        case "card.electricianUrl":
          this.cardForm.card = true;
          this.cardForm.type = 'electricianUrl';
          break;
        case "card.carUrl":
          this.cardForm.card = true;
          this.cardForm.type = 'carUrl';
          break;
      }
    },
    hangleGoUp() {
      let page = document.getElementsByClassName("main")[0];
      page.scrollIntoView();
    },
    sms() {
      this.isDisabled = true;
      const TIME_COUNT = 60;
      this.count = TIME_COUNT;
      this.ruleForm.code = "";

      let vm = this;
      vm.timer = window.setInterval(() => {
        if (vm.count > 0 && vm.count <= TIME_COUNT) {
          // 倒计时时不可点击
          vm.isDisabled = true;
          // 计时秒数
          vm.count--;
        } else {
          // 倒计时完，可点击
          vm.isDisabled = false;
          // 清空定时器!!!
          clearInterval(vm.timer);
          vm.timer = null;
        }
      }, 1000);
    },
    validator() {
      if (this.ruleForm.phone && this.ruleForm.projectId) {
        this.ruleForm.loading = true;
        this.$axios
            .patch("/Validator/", {
              projectId: this.ruleForm.projectId,
              phone: "+" + this.ruleForm.area + this.ruleForm.phone,
            })
            .then((res) => {
              this.ruleForm.loading = false;
              if (res.data.hasError == false) {
                this.sms();
                this.$message.success(this.$t("register.smsSuccess"));
              } else {
                this.$message.error(this.$t("register.smsError"));
              }
            })
            .catch((error) => {
              this.ruleForm.loading = false;
              this.$message.error(this.$t("register.error"));
            });
      } else {
        this.$message.error(this.$t("register.phone"));
      }
    },
    clear() {
      this.ruleForm.electricianUrl = "";
      this.ruleForm.name = "";
      this.ruleForm.sex = "";
      this.ruleForm.postcode = "";
      this.ruleForm.address1 = "";
      this.ruleForm.address = "";
      this.ruleForm.position = "";
      this.ruleForm.telNo = "";
      this.ruleForm.phoneNo = "";
      this.ruleForm.idCard = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          window.localStorage.setItem(this.id, JSON.stringify(this.ruleForm));

          if (formName == "ruleForm") {
            this.rulesPersonal.loading = true;
            this.$axios
                .get(
                    "/Validator/" +
                    "+" +
                    this.ruleForm.area +
                    this.ruleForm.phone +
                    "/" +
                    this.ruleForm.code
                )
                .then((res) => {
                  if (location.href.indexOf("127.0.0.1") == -1) {
                    if (res.data.hasError) {
                      this.$message.error(this.$t("register.validatorError"));
                      return;
                    } else {
                      this.ruleForm.show = false;
                      this.personalForm.show = true;
                    }
                  } else {
                    this.ruleForm.show = false;
                    this.personalForm.show = true;
                  }
                  if (!this.ruleForm.phoneNo) {
                    this.ruleForm.phoneNo =
                        this.ruleForm.phoneNo + this.ruleForm.phone;
                  }
                  this.rulesPersonal.loading = false;
                  this.$axios
                      .get(
                          "/Personal/" +
                          this.ruleForm.type +
                          "/" +
                          this.ruleForm.projectId +
                          "/" +
                          this.ruleForm.phone +
                          "/"
                      )
                      .then((res) => {
                        if (res.data.data) {
                          this.personalForm.show = false;
                          this.ruleForm.show = false;
                          this.qrcodeForm.show = true;
                          this.ruleForm.name = res.data.data.name;
                          this.ruleForm.company = res.data.data.company;
                          this.ruleForm.position = res.data.data.position;
                          this.ruleForm.remark = res.data.data.remark;
                          this.qrcodeForm.qrcode =
                              axios.defaults.baseURL.substr(
                                  0,
                                  axios.defaults.baseURL.length - 4
                              ) +
                              "/qrcode/" +
                              res.data.data.code;
                        } else {
                          // this.cardForm.show = true;
                        }
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                })
                .catch((error) => {
                  this.rulesPersonal.loading = false;
                  console.log(error);
                  this.$message.error(this.$t("register.error"));
                });
          } else if (formName == "personalForm") {


            if (this.page > 0) {
              for (let i = this.personalList.length - 1; i >= 0; i--) {
                if (this.personalList[i].idCard && !this.analyzeIDCard(this.personalList[i].idCard)) {
                  this.$message.error(this.ruleForm.idCard + '当前身份证号未成年');
                  return;
                }
                if (this.page != i) {
                  if (this.personalList[i].phoneNo == this.ruleForm.phoneNo) {
                    this.$message.error(this.$t("register.rePhoneNo"));
                    return;
                  } else if (
                      "+" + this.ruleForm.area ==
                      this.ruleForm.phoneNo
                  ) {
                    this.$message.error(
                        this.$t("register.input") + this.$t("register.phoneNo")
                    );
                    return;
                  } else if (
                      this.personalList[i].idCard == this.ruleForm.idCard
                  ) {
                    this.$message.error(this.$t("register.reIdCard"));
                    return;
                  }
                  for (let item of this.ruleForm.list) {
                    item.value = "";
                    switch (item.type) {
                      case 0:
                        if (item.values && item.values.length > 0) {
                          let flag = true;
                          for (let option of item.values) {
                            if (option.checked) {
                              flag = false;
                              if (item.value) item.value += "|" + option.value;
                              else item.value = option.value;
                            }
                          }
                          if (item.required == 1 && flag && this.match) {
                            this.$message.error(item.title);
                            return;
                          }
                        }
                        break;
                      case 2:
                      case 4:
                        if (item.values) {
                          let flag = true;
                          for (let option of item.values) {
                            if (option.checked) {
                              flag = false;
                              if (item.value) item.value += "|" + option.value;
                              else item.value = option.value;
                            }
                          }
                          if (item.required == 1 && flag) {
                            this.$message.error(item.title);
                            return;
                          } else if (
                              item.values[item.values.length - 1].checked &&
                              item.value &&
                              item.type == 4 &&
                              item.validator == "" &&
                              item.value.indexOf(
                                  item.values[item.values.length - 1].value
                              ) > -1
                          ) {
                            this.$message.error(
                                item.title +
                                ";" +
                                item.values[item.values.length - 1].value
                            );
                            return;
                          }
                        }
                        break;
                      case 8:
                        // if (item.required == 1 && !item.value && this.persons) {
                        //   this.$message.error(item.title);
                        //   return;
                        // }
                        break;
                    }
                  }
                }
              }
            } else {
              if (this.ruleForm.idCard && !this.analyzeIDCard(this.ruleForm.idCard)) {
                this.$message.error(this.ruleForm.idCard + '当前身份证号未成年');
                return;
              }
            }
            if (this.ruleForm.name == "") {
              this.$message.error(
                  this.$t("register.input") + this.$t("register.name")
              );
              return;
            }

            this.$axios
                .get(
                    "/Personal/" +
                    this.ruleForm.type +
                    "/" +
                    this.ruleForm.projectId +
                    "/" +
                    this.ruleForm.phoneNo +
                    "/"
                )
                .then((res) => {
                  if (res.data.data) {
                    this.$message.error(this.$t("register.rePhoneNo"));
                  } else {
                    this.ruleForm.address =
                        this.ruleForm.countryArea +
                        this.ruleForm.province +
                        this.ruleForm.city +
                        this.ruleForm.address1;

                    if (this.flag) {
                      this.ruleForm.verify = 0;
                      this.personalList[this.page] = JSON.parse(
                          JSON.stringify(this.ruleForm)
                      );
                      if (this.total == this.personalList.length - 1) {
                        this.confirmForm.show = true;
                        this.elseForm.show = false;
                        this.personalForm.show = false;
                      } else {
                        if (this.page <= this.total) {
                          this.elseForm.show = false;
                          this.personalForm.show = true;
                          this.page++;
                          if (this.personalList.length <= this.total) {
                            this.clear();
                          }
                          this.hangleGoUp();
                        } else {
                          this.confirmForm.show = true;
                          this.elseForm.show = false;
                          this.personalForm.show = false;
                        }
                      }
                    } else {
                      this.personalForm.loading = true;
                      this.elseForm.show = true;
                      this.personalForm.show = false;
                      this.personalForm.loading = false;
                      this.personalList[this.page] = JSON.parse(
                          JSON.stringify(this.ruleForm)
                      );
                    }
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
          } else if (formName == "elseForm") {
            this.flag = false;
            this.total = 0;
            for (let item of this.ruleForm.list) {
              item.value = "";
              switch (item.type) {
                case 0:
                  if (item.values && item.values.length > 0) {
                    let flag = true;
                    let i = 0;
                    for (let option of item.values) {
                      if (option.checked) {
                        if (item.labels && item.labels[i])
                          this.ruleForm.openId += "|" + item.labels[i];
                        flag = false;
                        if (item.value) item.value += "|" + option.value;
                        else item.value = option.value;
                      }
                      i++;
                    }
                    if (item.required == 1 && flag && this.match) {
                      this.$message.error(item.title);
                      return;
                    }
                  }
                  break;
                case 2:
                case 4:
                  if (item.values) {
                    let flag = true;
                    let i = 0;
                    for (let option of item.values) {
                      if (option.checked) {
                        if (item.labels && item.labels[i])
                          this.ruleForm.openId += "|" + item.labels[i];
                        flag = false;
                        if (item.value) item.value += "|" + option.value;
                        else item.value = option.value;
                      }
                      i++;
                    }
                    if (item.required == 1 && flag) {
                      this.$message.error(item.title);
                      return;
                    } else if (
                        item.values[item.values.length - 1].checked &&
                        item.value &&
                        item.type == 4 &&
                        item.validator == "" &&
                        item.value.indexOf(
                            item.values[item.values.length - 1].value
                        ) > -1
                    ) {
                      this.$message.error(
                          item.title +
                          ";" +
                          item.values[item.values.length - 1].value
                      );
                      return;
                    }
                  }
                  break;
                case 8:
                  // if (item.required == 1 && !item.value && this.persons) {
                  //   this.$message.error(item.title);
                  //   return;
                  // }
                  break;
              }
              if (
                  item.input == "registers" &&
                  item.value &&
                  ((item.value.indexOf("是") > -1 && localStorage.lang != "en") ||
                      (item.value.indexOf("Yes") > -1 && localStorage.lang == "en"))
              ) {
                this.flag = true;
              } else if (item.input == "persons" && this.flag) {
                if (item.validator) {
                  this.total = item.validator;
                  item.value = item.validator;
                } else {
                  this.total = 1;
                  item.value = 1;
                }
              } else if (item.item == "match") {
                this.ruleForm.disabled =
                    (item.value.indexOf("是") > -1 &&
                        localStorage.lang != "en") ||
                    (item.value.indexOf("Yes") > -1 && localStorage.lang == "en")
                        ? 1
                        : 0;
              }
            }

            if (this.flag) {
              this.ruleForm.verify = 1;
              this.personalList[this.page] = JSON.parse(
                  JSON.stringify(this.ruleForm)
              );
              if (this.page < this.total) {
                this.elseForm.show = false;
                this.personalForm.show = true;
                if (this.personalList.length <= this.total) {
                  this.clear();
                }
                this.page++;
                this.hangleGoUp();
              } else {
                this.confirmForm.show = true;
                this.elseForm.show = false;
                this.personalForm.show = false;
              }
            } else {
              this.personalList[this.page] = JSON.parse(
                  JSON.stringify(this.ruleForm)
              );

              this.save();
            }
          } else {
            this.personalList[this.page] = JSON.parse(
                JSON.stringify(this.ruleForm)
            );
            this.save();
          }
        }
      });
    },
    save() {
      this.confirmForm.loading = true;
      let i = 0;
      this.ruleForm = this.personalList[0];
      for (let item of this.personalList) {
        item.avatar = item.idCardUrl;
        item.remark = item.construction;
        item.remark1 = item.carNo;
        //item.phone = item.phoneNo;
        // item.idCard = this.ruleForm.phone;
        item.code = "";
        if (item.sexOthers && (item.sex == "其他" || item.sex == "Others")) {
          item.sex = item.sexOthers;
        }
        if (i > 0) {
          if (this.flag == false) {
            break;
          }
          item.phone = item.phoneNo.replace("+" + item.area, "");
        } else if (i == 0) {
          item.verify = 1;
        }
        this.$axios
            .post("/Personal/", item)
            .then((result) => {
              if (result.data.hasError) {
                this.$message.error(this.$t("register.error"));
                this.$message.error(result.data.message);
              } else {
                try {
                  this.$axios
                      .put(
                          "/PersonalProperty/" + result.data.data.personalId,
                          item.list
                      )
                      .then((res) => {
                        console.log(res);
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                } catch (error) {
                  console.log(error);
                }
                if (!this.qrcodeForm.show) {
                  this.elseForm.loading = false;
                  this.elseForm.show = false;
                  this.confirmForm.show = false;
                  this.qrcodeForm.show = true;
                  this.qrcodeForm.qrcode =
                      axios.defaults.baseURL.substr(
                          0,
                          axios.defaults.baseURL.length - 4
                      ) +
                      "/qrcode/" +
                      result.data.data.code;
                  localStorage.setItem("data", result.data.data);
                }
              }
            })
            .catch((error) => {
              this.confirmForm.loading = false;
              console.log(error);
            });
        i++;
      }
      if (this.flag) {
        setTimeout(() => {
          try {
            this.$axios
                .post("/Invite/SendList/", {
                  projectId: this.ruleForm.projectId,
                  title: this.ruleForm.lang + "_idCard_confirm",
                  isidCard: 1,
                  content: JSON.stringify(this.personalList),
                })
                .then((res) => {
                  console.log(res);
                });
          } catch (error) {
            console.log(error);
          }
        }, 3000);
      }
    },
    selectLang(val) {
      localStorage.lang = this.ruleForm.lang;
      this.$i18n.locale = this.ruleForm.lang;
      this.init(this.ruleForm.lang);
      //this.reloadPage();
    },
    selectProject() {
      this.$axios
          .get(`/Register/Project/${this.projectId}`)
          .then((res) => {
            if (res.data.data) {
              this.registers = [...res.data.data];
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    init(lang) {
      document.title = this.$t("register.page");

      if (this.ruleForm.lang != "en") {
        this.allarea = this.ruleForm.lang == "chs" ? allChs : allarea;
        this.allarea.forEach((e) => {
        })
      }
      this.rules = {
        countryArea: [
          {
            required: true,
            message:
                this.$t("register.input") + this.$t("register.countryArea"),
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("register.phone"),
            trigger: "change",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t("register.code"),
            trigger: "change",
          },
        ],
      };

      (this.cardRules = {
        agreeInfo: [
          {
            required: false,
            message: this.$t("register.select"),
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("register.input") + this.$t("register.name"),
            trigger: "change",
          },
        ],
        idCard: [
          {
            required: this.ruleForm.type === 7,
            validator: this.validateSfz,
            // message: this.$t("register.input") + this.$t("register.idCard"),
            trigger: "change",
          }
        ],
        idCardUrl: [
          {
            required: true,
            message: this.$t("register.input") + this.$t("register.idCard"),
            trigger: "change",
          }
        ],
        booth: [
          {
            required: true,
            message: this.$t("register.input") + this.$t("register.booth"),
            trigger: "change",
          }
        ],
        electricianUrl: [
          {
            required: false,
            message: this.$t("register.input") + this.$t("register.electricianUrl"),
            trigger: "change",
          }
        ],
        phoneNo: [
          {
            required: true,
            message: this.$t("register.input") + this.$t("register.phoneNo"),
            trigger: "change",
          },
        ],
        remark1: [
          {
            required: true,
            message: this.$t("register.input") + this.$t("register.remark1"),
            trigger: "change",
          },
        ],
        remark2: [
          {
            required: true,
            message: this.$t("register.input") + this.$t("register.remark2"),
            trigger: "change",
          },
        ],
      }),
          (this.sexs = []);
      this.restaurants = [];
      switch (this.ruleForm.lang) {
        case "zh":
          this.sexs.push({value: "先生", label: "先生"});
          this.sexs.push({value: "女士", label: "女士"});
          this.sexs.push({value: "其他", label: "其他"});
          for (let item of area) {
            this.restaurants.push({value: item.zh, code: item.code});
          }
          this.constructions = [
            {value: "电工作业证", label: "电工作业证"},
            {value: "高处作业证", label: "高处作业证"},
            {value: "焊接与热切割", label: "焊接与热切割"},
            {value: "普通施工人员", label: "普通施工人员"}];
          break;
        case "en":
          this.sexs.push({value: "Mr", label: "Mr"});
          this.sexs.push({value: "Mrs", label: "Mrs"});
          this.sexs.push({value: "Others", label: "Others"});
          for (let item of area) {
            this.restaurants.push({value: item.en, code: item.code});
          }
          this.constructions = [
            {value: "电工作业证", label: "Electrician Work Permit"},
            {value: "高处作业证", label: "High altitude work permit"},
            {value: "焊接与热切割", label: "Welding and thermal cutting"},
            {value: "普通施工人员", label: "not have"}]
          break;
        case "chs":
          this.sexs.push({value: "先生", label: "先生"});
          this.sexs.push({value: "女士", label: "女士"});
          this.sexs.push({value: "其他", label: "其他"});
          for (let item of area) {
            this.restaurants.push({value: item.chs, code: item.code});
          }
          this.constructions = [
            {value: "电工作业证", label: "電工作業證"},
            {value: "高处作业证", label: "高處作業證"},
            {value: "焊接与热切割", label: "焊接與熱切割"},
            {value: "普通施工人员", label: "無"}];
          break;
      }

      if (this.id) {
        this.$axios
            .get(`/Register/${this.id}`)
            .then((res) => {
              if (res.data.data) {
                if (res.data.data.bannerMoblie) {
                  this.bannerMoblie = res.data.data.bannerMoblie;
                }
                this.banner = res.data.data.banner;
                this.ruleForm.type = res.data.data.type;
                this.ruleForm.projectId = res.data.data.projectId;
                this.ruleForm.registerId = res.data.data.registerId;
                document.title = res.data.data.name;

                this.rulesPersonal = {
                  idCard: [
                    {
                      required: this.ruleForm.type === 7,
                      validator: this.validateSfz,
                      // message: this.$t("register.input") + this.$t("register.idCard"),
                      trigger: "change",
                    }
                  ],
                  idCardUrl: [
                    {
                      required: true,
                      message: this.$t("register.input") + this.$t("register.idCard"),
                      trigger: "change",
                    }
                  ],
                  company: [
                    {
                      required: this.ruleForm.type === 7,
                      validator: this.validateCompany,
                      // message: this.$t("register.input") + this.$t("register.company"),
                      trigger: "change",
                    },
                  ],
                  companyEn: [
                    {
                      required: true,
                      validator: this.validateCompany,
                      // message: this.$t("register.input") + this.$t("register.companyEn"),
                      trigger: "change",
                    },
                  ],
                  department: [
                    {
                      required: false,
                      message: this.$t("register.input") + this.$t("register.department"),
                      trigger: "change",
                    },
                  ],
                  countryArea: [
                    {
                      required: this.ruleForm.type !== 8,
                      message:
                          this.$t("register.input") + this.$t("register.countryArea"),
                      trigger: "change",
                    },
                  ],
                  province: [
                    {
                      required: this.ruleForm.type !== 8,
                      message: this.$t("register.input") + this.$t("register.province"),
                      trigger: "change",
                    },
                  ],
                  city: [
                    {
                      required: this.ruleForm.type !== 8,
                      message: this.$t("register.input") + this.$t("register.city"),
                      trigger: "change",
                    },
                  ],
                  electricianUrl: [
                    {
                      required: this.ruleForm.type === 7,
                      message: this.$t("register.input") + this.$t("register.electricianUrl"),
                      trigger: "change",
                    }
                  ],
                  booth: [
                    {
                      required: true,
                      message: this.$t("register.input") + this.$t("register.booth"),
                      trigger: "change",
                    }
                  ],
                  construction: [
                    {
                      required: true,
                      message: this.$t("register.input") + this.$t("register.electrician"),
                      trigger: "change",
                    }
                  ],
                  carNo: [
                    {
                      required: this.ruleForm.type === 8,
                      message: this.$t("register.input") + this.$t("register.carNo"),
                      trigger: "change",
                    }
                  ],
                  carUrl: [
                    {
                      required: this.ruleForm.type === 8,
                      message: this.$t("register.input") + this.$t("register.carUrl"),
                      trigger: "change",
                    }
                  ],
                  idCard: [
                    {
                      required: true,
                      validator: this.validateSfz,
                      // message: this.$t("register.input") + this.$t("register.idCard"),
                      trigger: "change",
                    }
                  ],
                  agreeInfo: [
                    {
                      required: false,
                      message: this.$t("register.select"),
                      trigger: "change",
                    },
                  ],
                  name: [
                    {
                      required: true,
                      message: this.$t("register.input") + this.$t("register.name"),
                      trigger: "change",
                    },
                  ],
                  phoneNo: [
                    {
                      required: true,
                      message: this.$t("register.input") + this.$t("register.phoneNo"),
                      trigger: "change",
                    },
                  ],
                  address1: [
                    {
                      required: this.ruleForm.type !== 8,
                      message: this.$t("register.input") + this.$t("register.address1"),
                      trigger: "change",
                    },
                  ],
                  position: [
                    {
                      required: false,
                      message: this.$t("register.input") + this.$t("register.position"),
                      trigger: "change",
                    },
                  ],
                  sex: [
                    {
                      required: false,
                      message: this.$t("register.input") + this.$t("register.sex"),
                      trigger: "change",
                    },
                  ],
                };
              }
            })
            .catch((error) => {
              console.log(error);
            });
        this.$axios
            .get("/Property/register/" + this.id)
            .then((res) => {
              if (res.data.data) {
                this.list = [...res.data.data];
                this.list = this.list.sort((a, b) => {
                  return a.indexNo - b.indexNo;
                });
                this.ruleForm.list = [];
                let i = 0;
                for (let item of this.list) {
                  item.labels = item.labels ? item.labels.split("|") : [];
                  switch (item.type) {
                    case 0:
                    case 2:
                    case 4:
                      this.ruleForm.list.push(item);
                      item.values = [];
                      item.value = "";
                      item.validator = "";
                      switch (this.ruleForm.lang) {
                        case "en":
                          item.title = item.englishName;
                          if (item.englishOption) {
                            for (let str of item.englishOption.split("|")) {
                              item.values.push({checked: false, value: str});
                            }
                          }
                          break;
                        case "chs":
                          item.title = item.traditionalName;
                          if (item.traditionalOption) {
                            for (let str of item.traditionalOption.split("|")) {
                              item.values.push({checked: false, value: str});
                            }
                          }
                          break;
                        default:
                          item.title = item.name;
                          if (item.options) {
                            for (let str of item.options.split("|")) {
                              item.values.push({checked: false, value: str});
                            }
                          }
                          break;
                      }
                      break;
                    case 8:
                      this.ruleForm.list.push(item);
                      if (item.input == "persons") {
                        item.value = 1;
                      }
                      switch (this.ruleForm.lang) {
                        case "en":
                          item.title = item.englishName;
                          break;
                        case "chs":
                          item.title = item.traditionalName;
                          break;
                        default:
                          item.title = item.name;
                          break;
                      }
                      break;
                  }
                  i++;
                }

                let obj = window.localStorage.getItem(this.id);
                if (obj) {
                  this.ruleForm = JSON.parse(obj);
                  this.ruleForm.show = false;
                  this.cardForm.show = false;
                  this.personalForm.show = true;
                  this.qrcodeForm.show = false;
                  this.prev('personalForm');
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.ruleForm.sourceId = this.$route.query.sourceId;
    this.ruleForm.lang = "zh";
    this.$i18n.locale = "zh";
    if (!this.id) {
      this.$axios
          .get(`/Project/ProjectType/1`)
          .then((res) => {
            if (res.data.data) {
              this.projects = [...res.data.data];
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }
    if (this.$route.query.lang) {
      this.ruleForm.lang = this.$route.query.lang;
      localStorage.lang = this.ruleForm.lang;
      this.$i18n.locale = this.ruleForm.lang;
    }
    this.init();
  },
  mounted() {
  },
  // beforeMount() {
  //   this.updateCity();
  //   this.updateDistrict();
  // },
  // computed: {},
  // watch: {
  //   prov() {
  //     this.updateCity();
  //     this.updateDistrict();
  //   },
  //   city() {
  //     this.updateDistrict();
  //   },
  // },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 750px) {
  .main {
    width: 100%;
    min-height: 100%;

    .ruleForm {
      position: absolute;
      top: 70vw;
    }
  }

  .qrcodeCard {
    z-index: 2;
    position: absolute;
    width: 60%;
    padding-left: 20%;
    top: 80vw;
    font-size: 0.045vw;
  }

  .qrcodeCard img {
    width: 45vw !important;
  }

  .qrcodeView {
    z-index: 2;
    position: absolute;
    width: 60%;
    padding-left: 20%;
    top: 77vw;
    font-size: 0.045vw;
  }

  .qrcodeView img {
    width: 30vw !important;
  }

  .footer {
    // position: fixed;
    // bottom: 10px;
    height: 60px;
    text-align: center;

    a {
      font-size: 10px;
    }

    left: 0px;
    width: 100%;
  }
}

@media screen and (min-width: 750px) {
  .main {
    padding-left: 25%;
    width: 50%;
    max-width: 50%;
    left: 25%;
  }

  .ruleForm {
    position: absolute;
    max-width: 40%;
    top: 36vw;
  }

  .qrcodeCard {
    z-index: 2;
    position: absolute;
    width: 60%;
    padding-left: 20%;
    top: 40vw;
    font-size: 0.045vw;
  }

  .qrcodeCard img {
    width: 23vw !important;
  }

  .qrcodeView {
    z-index: 2;
    position: absolute;
    width: 60%;
    padding-left: 20%;
    top: 38vw;
    font-size: 0.045vw;
  }

  .qrcodeView img {
    width: 20vw !important;
  }

  .footer {
    // position: fixed;
    // bottom: 10px;
    height: 60px;
    text-align: center;

    a {
      font-size: 10px;
    }
  }
}

.register-page {
  .question-select {
    height: 20px;
    font-size: 16px;
  }

  .question-select select {
    border-radius: 5px;
    box-shadow: 0 0 5px #ccc;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: none;
    outline: none;
    height: 100%;
    padding: 0 20px;
    color: #333;
  }

  span {
    font-size: 16px;
  }

  .el-checkbox.is-bordered {
    height: auto !important;
    vertical-align: middle !important;
    width: 100%;
  }

  .el-radio--medium.is-bordered {
    height: auto !important;
    vertical-align: middle !important;
    width: 100%;
    padding-bottom: 10px !important;
  }

  body {
    max-width: 100%;
  }

  .main {
    width: 100%;
    height: auto;
  }

  .el-input__inner {
    height: 42px !important;
  }

  .flag-list-box {
    background: #fff !important;
  }

  .el-radio__label {
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    vertical-align: middle !important;
  }

  .el-checkbox__label {
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    vertical-align: middle !important;
  }

  .foot {
    height: 100%;
    width: 100%;
    z-index: 999;
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5) !important;
  }

  .qrcode {
    z-index: 2;
    position: absolute;
    width: 80%;
    padding-left: 10%;
    top: 3.3rem;
    font-size: 4px;
    text-align: left;
  }

  .el-steps {
    margin-top: 15px;
  }

  .el-step__title {
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: 400 !important;
  }

  .el-cascader-menu {
    min-width: 0 !important;
  }

  .el-upload--text {
    display: none;
  }

  .footerTip {
    margin: 10px;
    white-space: normal;
  }

  .photograph {
    position: fixed;
    bottom: 122px;
    line-height: 60px;
    height: 60px;
    width: 100%;
    background: #ffffff;
    opacity: 1;
    border-radius: 20px 20px 0px 0px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #161616;
    text-align: center;
    vertical-align: middle;
  }

  input[type="file"] {
    opacity: 0;
    display: none;
  }

  .gallery {
    line-height: 60px;
    height: 60px;
    position: fixed;
    bottom: 61px;
    width: 100%;
    background: #ffffff;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #161616;
    text-align: center;
    vertical-align: middle;
  }

  .cancel {
    position: fixed;
    bottom: 0;
    line-height: 60px;
    width: 100%;
    background: #ffffff;
    opacity: 1;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #161616;
    text-align: center;
    vertical-align: middle;
  }

  .tel-container {
    display: flex;
    align-items: center;
    background-color: #fbfbfb;
    border-radius: 5px;
  }

  p {
    margin-left: 20px;
  }

  .next {
    float: right;
  }

  .lang {
    width: 120px;
    float: right;
  }

  .card {
    display: inline-block;
    float: left;
    width: 120px;
    height: 120px;
    background: rgb(2, 113, 2);
    box-shadow: 2px 2px 5px rgba(2, 37, 104, 0.15);
    opacity: 1;
    border-radius: 21px;
  }

  .flag-list-box {
    background: #fff;
  }

  .card p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 15px;
    color: #ffffff;
    opacity: 1;
    margin-left: 0px;
    margin-top: 10px;
    text-align: center;
  }

  .card img {
    margin-left: 32px;
    margin-top: 25px;
    width: 56px;
  }

  .edit p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 15px;
    color: #ffffff;
    opacity: 1;
    margin-left: 0px;
    text-align: center;
  }

  .sms {
    background-color: rgb(102, 177, 255);
    color: #fff;
  }

  .edit img {
    margin-left: 32px;
    margin-top: 22px;
    width: 56px;
  }

  .edit {
    float: right;
    display: inline-block;
    width: 120px;
    height: 120px;
    background: #3578fa;
    box-shadow: 2px 2px 5px rgba(2, 37, 104, 0.15);
    opacity: 1;
    border-radius: 21px;
  }

  form {
    padding-left: 6%;
    margin-top: 30px;
    margin-bottom: 30px;
    width: 88%;
    height: auto;
  }

  img {
    width: 100%;
  }

  h2 {
    text-align: center;
    font-size: 20px;
  }

  .el-form {
    padding-bottom: 30px;
    padding-top: 30px;
  }

  * {
    font-size: 14px;
  }
}</style>
